const stopPublish = (
  peerConnection: RTCPeerConnection | undefined,
  websocket: WebSocket | undefined,
  callbacks: any
) => {
  if (peerConnection) {
    peerConnection.close();
    if (callbacks.onSetPeerConnection) {
      callbacks.onSetPeerConnection({peerConnection: undefined});
    }
  }

  if (websocket) {
    websocket.close();
    if (callbacks.onSetWebsocket) {
      callbacks.onSetWebsocket({websocket: undefined});
    }
  }

  if (callbacks.onPublishStopped) {
    callbacks.onPublishStopped();
  }
};

export default stopPublish;
